import type { MentorData } from '../types'

export const MOCKED_DATA: MentorData = {
  // card
  name: 'Radosław Myśliwiec',
  aboutMe:
    'Cześć! Jestem założycielem AlgoAcademy i inżynierem oprogramowania specjalizującym się w algorytmice, sztucznej inteligencji i technologiach webowych. Jako mentor, od ponad sześciu lat wspieram moich podopiecznych w przygotowaniu do olimpiad, konkursów i rozmów kwalifikacyjnych. Wielu z nich zdobywa czołowe miejsca w zawodach i znajduje zatrudnienie w wiodących firmach branży IT.',
  photoUrl: '/images/radoslaw-mysliwiec.jpg',
  cvUrl: undefined,
  email: 'radoslaw.mysliwiec@algoacademy.pl',

  socials: {
    githubUrl: 'https://github.com/ranz7',
    linkedinUrl: 'https://www.linkedin.com/in/radoslaw-mysliwiec/',
    youtubeUrl: undefined
  },

  // technologies
  technologies: {
    skills: [
      {
        name: 'C',
        level: 'expert' as const
      },
      {
        name: 'C++',
        level: 'expert' as const
      },
      {
        name: 'JavaScript',
        level: 'advanced' as const
      },
      {
        name: 'TypeScript',
        level: 'advanced' as const
      },
      {
        name: 'SQL',
        level: 'advanced' as const
      },
      {
        name: 'Node.js',
        level: 'advanced' as const
      },
      {
        name: 'PostgreSQL',
        level: 'advanced' as const
      },
      {
        name: 'React',
        level: 'advanced' as const
      },
      {
        name: 'Next.js',
        level: 'advanced' as const
      },
      {
        name: 'React Query',
        level: 'proficient' as const
      },
      {
        name: 'TailwindCSS',
        level: 'advanced' as const
      },
      {
        name: 'tRPC',
        level: 'advanced' as const
      },
      {
        name: 'DrizzleORM',
        level: 'advanced' as const
      },
      {
        name: 'Bash',
        level: 'proficient' as const
      },
      {
        name: 'Docker',
        level: 'proficient' as const
      },
      {
        name: 'Git',
        level: 'advanced' as const
      },
      {
        name: 'GitHub',
        level: 'advanced' as const
      },
      {
        name: 'Vercel',
        level: 'proficient' as const
      },
      {
        name: 'Cursor',
        level: 'proficient' as const
      },
      {
        name: 'Claude Code',
        level: 'proficient' as const
      },
      {
        name: 'Coolify',
        level: 'proficient' as const
      }
    ]
  },

  courses: [
    {
      name: 'Podstawy Programowania',
      skills: [
        {
          name: 'HTML'
        },
        {
          name: 'CSS'
        },
        {
          name: 'JavaScript'
        },
        {
          name: 'TypeScript'
        }
      ],
      description:
        'Kurs dla ambitnych uczniów szkół podstawowych, którzy rozpoczynają przygodę z programowaniem. Pomimo tego, że jest skierowany do początkujących, od pierwszych zajęć pracujemy na technologiach i narzędziach używanych przez profesjonalistów. Uczeń szybko zobaczy efekty: własną grę, interaktywną stronę, wizualizacje napisanych algorytmów czy aplikację z elementami AI.'
    },
    {
      name: 'Algorytmika - Zostań finalistą Olimpiady Informatycznej',
      skills: [
        {
          name: 'C++'
        },
        {
          name: 'Algorytmy'
        },
        {
          name: 'Struktury Danych'
        }
      ],
      description:
        'Na tym kursie skupiamy się na zaawansowanych algorytmach, technikach optymalizacji i strategiach rozwiązywania zadań konkursowych. Idealny dla ambitnych uczniów chcących osiągnąć sukces w olimpiadach. Kurs wymaga podstawowych umiejętności programowania w C++. Jest idealny dla tych, którzy mieli wcześniejsze doświadczenie z zadaniami olimpijskimi.'
    },
    {
      name: 'Rozmowy kwalifikacyjne - Zdobądź wymarzoną pracę w branży IT',
      skills: [
        {
          name: 'Algorytmy'
        },
        {
          name: 'Struktury Danych'
        },
        {
          name: 'Design systemów'
        }
      ],
      description:
        'Praktyczne przygotowanie do rozmów kwalifikacyjnych w branży IT. Omawiamy istotne pytania techniczne, zadania algorytmiczne i przeprowadzamy symulacje rozmów rekrutacyjnych. Pokazujemy, jak prezentować swoje umiejętności i rozwiązywać problemy pod presją czasu, aby wyróżnić się w procesie rekrutacji.'
    }
  ],

  education: [
    {
      institution: 'AGH University of Krakow',
      degree: 'Inżynier, Informatyka i Systemy Inteligentne',
      description:
        'Studiuję Informatykę i Systemy Inteligentne z naciskiem na sztuczną inteligencję i algorytmikę. Założyłem koło naukowe AlgoAGH i jestem członkiem koła naukowego BIT. Dwukrotnie uczestniczyłem w Programie Tutorskim AGH i zostałem wybrany do Programu Mentorskiego AGH dla najzdolniejszych studentów. Wielokrotnie reprezentowałem AGH na międzynarodowych konkursach programistycznych ICPC.',
      skills: [
        {
          name: 'Sztuczna inteligencja',
          level: 'advanced' as const
        },
        {
          name: 'Algorytmy',
          level: 'advanced' as const
        },
        {
          name: 'Struktury Danych',
          level: 'advanced' as const
        },
        {
          name: 'Python',
          level: 'advanced' as const
        },
        {
          name: 'Machine Learning',
          level: 'proficient' as const
        },
        {
          name: 'Competitive Programming',
          level: 'advanced' as const
        }
      ],
      from: '2022',
      to: '2026'
    }
  ],

  experiences: [
    {
      role: 'Założyciel, Tech Lead, Mentor',
      company: 'AlgoAcademy',
      description:
        'Założyłem i prowadzę zespół ponad 20 programistów, designerów i mentorów tworzących platformę e-learningową. Zarządzam projektem AlgoAcademy w pełnym cyklu rozwoju oprogramowania. Przeprowadziłem ponad 3000 godzin mentoringu indywidualnego i szkoleń grupowych.',
      from: '2023',
      to: 'obecnie',
      skills: [
        {
          name: 'Coaching i mentoring',
          level: 'advanced' as const
        },
        {
          name: 'Algorytmika',
          level: 'advanced' as const
        },
        {
          name: 'Przygotowanie do olimpiad',
          level: 'advanced' as const
        },
        {
          name: 'C++',
          level: 'advanced' as const
        },
        {
          name: 'JavaScript',
          level: 'advanced' as const
        },
        {
          name: 'TypeScript',
          level: 'advanced' as const
        },
        {
          name: 'React',
          level: 'advanced' as const
        },
        {
          name: 'Next.js',
          level: 'advanced' as const
        },
        {
          name: 'TailwindCSS',
          level: 'advanced' as const
        },
        {
          name: 'tRPC',
          level: 'advanced' as const
        },
        {
          name: 'DrizzleORM',
          level: 'advanced' as const
        },
        {
          name: 'PostgreSQL',
          level: 'advanced' as const
        },
        {
          name: 'Node.js',
          level: 'advanced' as const
        },
        {
          name: 'Docker',
          level: 'advanced' as const
        },
        {
          name: 'React Query',
          level: 'advanced' as const
        },
        {
          name: 'Zarządzanie zespołem',
          level: 'advanced' as const
        },
        {
          name: 'Startupy',
          level: 'advanced' as const
        }
      ]
    },
    {
      role: 'Senior Software Engineer (Full Stack Development & AI Automation)',
      company: 'Docplanner',
      description:
        'Docplanner jako pierwsza polska firma technologiczna osiągnęła wycenę przekraczającą miliard dolarów. Współpracuję tam bezpośrednio z CEO oraz dyrektorami marketingu, sprzedaży i produktu z kilkunastu krajów. Rozwijam wewnętrzne narzędzia firmy, wykorzystując najnowsze technologie AI. Wcześniej pracowałem tam nad rozwiązaniami sztucznej inteligencji dla pracowników służby zdrowia w zespole Noa. Stworzyłem algorytm przetwarzania audio, którego zadaniem jest poprawianie jakości danych do treningu wewnętrznego modelu AI transkrypcji mowy. Stworzyłem pacjenta AI - głosowego agenta do testowania systemów.',
      from: '2025',
      to: 'obecnie',
      skills: [
        {
          name: 'Sztuczna inteligencja',
          level: 'advanced' as const
        },
        {
          name: 'Przetwarzanie audio',
          level: 'advanced' as const
        },
        {
          name: 'Full-stack development',
          level: 'advanced' as const
        },
        {
          name: 'AI Agents',
          level: 'proficient' as const
        },
        {
          name: 'TypeScript',
          level: 'proficient' as const
        },
        {
          name: 'PHP',
          level: 'proficient' as const
        },
        {
          name: 'Laravel',
          level: 'proficient' as const
        }
      ]
    },
    {
      role: 'Site Reliability Software Engineer',
      company: 'Google',
      description:
        'Stworzyłem w ramach stażu narzędzie generowania kodu, które następnie zintegrowałem z wewnętrznym IDE dla programistów Googla. Pracowałem w zespole infrastruktury, zajmującym się utrzymywaniem i skalowaniem systemów wewnętrznych.',
      from: '2025',
      skills: [
        {
          name: 'Software Engineering',
          level: 'advanced' as const
        },
        {
          name: 'Go',
          level: 'advanced' as const
        },
        {
          name: 'TypeScript',
          level: 'advanced' as const
        },
        {
          name: 'System Design',
          level: 'proficient' as const
        },
        {
          name: 'Large Scale Systems',
          level: 'proficient' as const
        },
        {
          name: 'Kubernetes',
          level: 'proficient' as const
        }
      ]
    },
    {
      role: 'Mentor w obszarze programowania i technologii',
      company: 'Akademia Ivy Poland',
      description:
        'Przygotowywałem wybitnych uczniów do olimpiad informatycznych oraz wspierałem studentów w doskonaleniu umiejętności technicznych. Wielu moich podopiecznych kontynuowało naukę na prestiżowych uczelniach, takich jak Harvard czy Stanford.',
      from: '2022',
      to: '2025',
      skills: [
        {
          name: 'Coaching i mentoring',
          level: 'advanced' as const
        },
        {
          name: 'Przygotowanie do olimpiad',
          level: 'advanced' as const
        },
        {
          name: 'Algorytmika',
          level: 'advanced' as const
        },
        {
          name: 'Przygotowanie na studia za granicą',
          level: 'advanced' as const
        }
      ]
    }
  ],

  projects: [
    {
      name: 'Aplikacja fiszkowa z algorytmem SuperMemo 15',
      description:
        'Webowa aplikacja fiszkowa implementująca zaawansowany algorytm SuperMemo 15 do optymalizacji nauki. Aplikacja wykorzystuje algorytmy adaptacyjne do personalizacji interwałów powtórek, znacznie zwiększając efektywność nauki.',
      imageUrl: '/images/algo-avatar.png',
      projectUrl: undefined,
      skills: [
        {
          name: 'Algorytmy adaptacyjne',
          level: 'advanced' as const
        },
        {
          name: 'Web Development',
          level: 'advanced' as const
        },
        {
          name: 'Machine Learning',
          level: 'proficient' as const
        }
      ]
    },
    {
      name: 'System automatycznego przydzielania zadań',
      description:
        'Aplikacja do automatycznego przydzielania zadań pracownikom z wykorzystaniem symulacji agentowej. System analizuje umiejętności pracowników, obciążenie i priorytety zadań, aby optymalnie rozdzielić pracę w zespole.',
      imageUrl: '/images/algo-avatar.png',
      projectUrl: undefined,
      skills: [
        {
          name: 'Symulacja agentowa',
          level: 'advanced' as const
        },
        {
          name: 'Algorytmy optymalizacyjne',
          level: 'advanced' as const
        },
        {
          name: 'System Design',
          level: 'proficient' as const
        }
      ]
    },
    {
      name: 'Algorytm przetwarzania audio w czasie rzeczywistym',
      description:
        'Zaawansowany algorytm przetwarzania audio stworzony w Docplanner dla zespołu Noa.ai. Algorytm umożliwia skuteczniejsze przygotowanie danych do treningu wewnętrznego modelu AI rozpoznawania mowy, znacząco poprawiając jakość przetwarzania audio.',
      imageUrl: '/images/algo-avatar.png',
      projectUrl: undefined,
      skills: [
        {
          name: 'Przetwarzanie sygnałów',
          level: 'advanced' as const
        },
        {
          name: 'Machine Learning',
          level: 'advanced' as const
        },
        {
          name: 'AI/ML',
          level: 'advanced' as const
        }
      ]
    }
  ],

  reviews: [
    {
      id: '1',
      reviewerName: 'Michał',
      reviewerRating: 5,
      title: 'Życiowe doświadczenie',
      description:
        'Radosław - osoba, która prowadzi firmę, jest niezwykle utalentowanym człowiekiem i bardzo dokładnie wie, na czym polega nauczanie. Nie mówię tutaj tylko o sporych umiejętnościach w przekazywaniu wiedzy oraz wieloletnim doświadczeniu, ale również o świadomości, jak bardzo można zmienić człowieka, po prostu będąc dobrym mentorem. Na tyle, ile udało mi się poznać Radosława, wiem, że to, co robi, to nie tylko czysta praca i cel, lecz droga, przy której zawsze jest obok. Niezależnie od problemu zawsze daje niebanalne analogie oraz ciekawe zagadki, które otwierają kompletnie nowe pole widzenia za każdym razem. Sam fakt umiejętności połączenia ogromnej wiedzy teoretycznej wraz z przecudownymi analogiami wykorzystywania ich w codziennym życiu jest czymś, co zawsze wzbudza we mnie dreszcze ekscytacji. Muszę serio podkreślić, świetną metodykę przekazywania wiedzy, gdzie zawsze to właśnie uczeń dochodzi sam do wniosków i rezultatu, będąc kierowany odpowiednimi pytaniami i analogiami przez Radosława. Nigdy bym nie pomyślał, że może istnieć dobry system edukacji, a jednak życie zaskakuje. Mógłbym pisać godzinami, jak wiele świetnych technik poznałem dzięki Niemu, jednak trzeba to przeżyć samemu!\n\nŻyczę każdemu możliwości poznania i posiadania takiej osoby jak Radosław, bo jest to dosłownie doświadczenie odmieniające życie :)',
      reviewerAvatarUrl:
        'https://lh3.googleusercontent.com/a-/ALV-UjWTwhU5xZjlelUNXaK7_GwWXJgpQeJ_TWT2srUlWv7SOUez3xk=w72-h72-p-rp-mo-br100'
    },
    {
      id: '2',
      reviewerName: 'Bartosz',
      reviewerRating: 5,
      title: 'Mentoring oparty na praktyce',
      description:
        'Korzystam z mentoringu i myślę, że moja opinia może komuś pomóc 🙂\n\nMentoring u Radka to program skoncentrowany na rozwoju. Indywidualnie dobrane zadania, stały kontakt z mentorem i wiele innych elementów umożliwiają naprawdę szybki postęp.\n\nMentoring oparty jest na uczeniu poprzez praktykę. Teoria nie jest podawana przed partią zadań, ale raczej krystalizuje się w TRAKCIE ich robienia. Na początku miałem jednak wątpliwości co do skuteczności tego podejścia. Wydało mi się ono bardzo chaotyczne. Z czasem wprowadzaliśmy nawyki, które pozwoliły wyciągnąć z zadań jak najwięcej wniosków np. poprzez zadawanie odpowiednich pytań, zapisywanie obserwacji, popełnionych błędów, itd. Sprawiło to, że zacząłem samemu dochodzić do pewnych przemyśleń, które z pomocą mentora, przekuwałem w teorię.\n\nAle trzeba nastawić się, że nie będzie to lekka droga, bo jak to twierdzi mój mentor - prawdziwe uczenie się zaczyna tam, gdzie kończy się strefa komfortu.\nJeżeli nigdy nie doświadczyłeś uczenia poprzez praktykę, to początek może być, tak jak u mnie - wypełniony buntem wobec tej metody, ale warto jej zaufać i kontynuować podróż 🙂\n\nPS. Korzystaj z możliwości zadawania pytań mentorowi. Ja zacząłem to robić zbyt późno i bardzo tego żałuję...\n\nZdecydowanie polecam 🙂',
      reviewerAvatarUrl:
        'https://lh3.googleusercontent.com/a/ACg8ocIh0jP3YM_guy_ui1JzOuhh8tirgmIcUITm7wXC2r9SVPtwGQ=w72-h72-p-rp-mo-br100'
    },
    {
      id: '3',
      reviewerName: 'Jakub',
      reviewerRating: 5,
      title: 'Kurs "Przygotuj się do interview"',
      description:
        'Ukończyłem kurs "Przygotuj się do interview" i mogę go polecić każdemu, kto chce na poważnie podejść do doskonalenia umiejętności rozwiązywania algorytmicznych zadań rekrutacyjnych.\n\nZ kursu można wynieść najwięcej, inwestując czas w samodzielne rozwiązywanie zadań dołączonych do każdych zajęć. Są one dostosowane do różnych poziomów uczestników, a przy tym na tyle ciekawe, że uważam je za lepsze niż wiele popularnych zestawów dostępnych w internecie.\n\nRadek, prowadzący zajęcia, wykazuje się ogromną cierpliwością i chęcią nauczenia – nawet gdy nie potrafiłem dokładnie nazwać, czego nie rozumiem, poświęcał czas, żeby mi to wytłumaczyć. Co więcej, nie ogranicza się tylko do materiału kursowego – chętnie odpowiada na pytania związane z rozwojem kariery, dzięki czemu uzyskałem odpowiedzi, których samodzielnie i bezskutecznie szukałem przez lata.\n\nPodoba mi się również to, że prowadzący aktywnie zbiera opinie uczestników i eksperymentuje z metodami nauczania, zamiast bazować na szkolno-uczelnianym podejściu opartym na przekazywaniu wiedzy encyklopedycznej.\n\nPolecam!',
      reviewerAvatarUrl:
        'https://lh3.googleusercontent.com/a-/ALV-UjV_t2EJc0sFIUztF0SG1l3gNkluYEMGnpO_8s5uBFRQGtfyr1A=w72-h72-p-rp-mo-br100'
    }
  ],

  howIWorkMarkdown: `## Jak wygląda współpraca ze mną

**Uczniowie wiedzą, dlaczego się uczą**
Zawsze pokazuję praktyczne zastosowania omawianych zagadnień i ich istotność w kontekście rzeczywistych problemów. Przedstawiam realne scenariusze, z którymi uczniowie mogą się spotkać w przyszłej karierze zawodowej. Dzięki temu nie tylko przyswajają wiedzę, ale także rozumieją, jak mogą ją wykorzystać w praktyce.

**Uczniowie poznają problem i z moją pomocą dochodzą do rozwiązania**
Stosuję podejście "od problemu do rozwiązania". Zaczynam od zdefiniowania problemu, a następnie angażuję uczniów do wspólnego dyskutowania i dzielenia się pomysłami na rozwiązanie. W ten sposób uczeń dochodzi do rozwiązania naturalnie. Najlepiej, aby uczeń zapoznał się z danym problemem jeszcze przed zajęciami, co zachęca do dokładniejszego zrozumienia i kształtuje samodzielność.

**Indywidualne podejście**
W moim przekonaniu jest to kluczowa cecha optymalnego rozwoju. Każdy uczeń wymaga unikalnego podejścia ze względu na dwa istotne czynniki: predyspozycje oraz zainteresowania.

Podczas oceny predyspozycji ucznia, skupiam się na aspektach takich jak aktualna sumienność, pracowitość, zdolności i chęci do uczenia się. Moim celem nie jest zmienianie predyspozycji ucznia, lecz pokazanie, że warto poświęcić czas i włożyć wysiłek w swój rozwój, niezależnie od nich.

Predyspozycje uczniów mogą różnić się znacząco. Uczniowie o silnych predyspozycjach z mniejszym trudem poświęcają więcej czasu na naukę, przyswajają nowe pojęcia, łączą różne idee i skuteczniej stosują zdobyte umiejętności do rozwiązywania bardziej złożonych problemów. Dlatego im silniejsze predyspozycje ucznia, tym bardziej mogę pozwolić sobie na pokazywanie problemu w pełnej złożoności, pokazywanie go w innych kontekstach, mogę zbaczać z głównego tematu oraz prowadzić zajęcia bardziej w formie dialogu, a nie wykładu. W przypadku ucznia o słabszych predyspozycjach podejście bardziej schematyczne może okazać się skuteczniejsze w osiągnięciu zamierzonego celu.

W szczególności chcę umożliwić uczniom rozwijanie ich mocnych stron oraz zainteresowań, co pozwoli im na budowanie pewności siebie i czerpanie większej satysfakcji z nauki i pracy. Odniesienie nowych zagadnień do obszarów zainteresowań ucznia pomaga w budowaniu większej motywacji do nauki. Dlatego jeżeli jest to możliwe, staram się dobierać problemy i przykłady w oparciu o zainteresowania ucznia.

**Uczę kreatywności i samodzielności**
Stawiam szczególny nacisk na umiejętności takie jak:
- Kształtowanie nawyków – uczę, jak budować pozytywne nawyki wspierające ciągły rozwój.
- Skuteczna nauka – pokazuję, jak zdobywać wiedzę na własną rękę, korzystając z różnorodnych źródeł.
- Ocena jakości źródeł – uczę, jak można ocenić jakość i wiarygodność źródeł.
- Organizacja wiedzy i czasu – pomagam w rozwijaniu umiejętności planowania i efektywnego notowania.
- Korzystanie z technologii – uczę, jak wykorzystywać nowoczesne narzędzia i AI w procesie nauki.
- Kompetencje miękkie – zwracam uwagę na umiejętności interpersonalne, takie jak: skuteczena komunikacja, efektywne prezentowanie pomysłów i strategie argumentacji.

## Moje osiągnięcia

**Konkursy programistyczne**
- Finalista Olimpiady Informatycznej
- Reprezentant AGH na międzynarodowych konkursach ICPC (2023-2025)
- TOP 10 w rankingu pl.spoj.com (8. miejsce spośród ponad 70 000 użytkowników)
- Uczestnik Europejskich Mistrzostw w Programowaniu Zespołowym (EUC 2025)
- Uczestnik Mistrzostw Europy Środkowej w Programowaniu Zespołowym (CERC 2023, 2024)
- Uczestnik Akademickich Mistrzostw Polski w Programowaniu Zespołowym (AMPPZ 2023, 2024)

**Sukcesy moich uczniów**
- Młodsi podopieczni: czołowe miejsca w olimpiadach informatycznych
- Starsi podopieczni: kariery w Google, Samsung, Harvard, Stanford
`
}
